var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { sdsCustomElement } from '../../utilities/custom-components';
import { freezePosition } from '../../utilities/dom';
import { SdsTreeDataNodeBase } from './_sds-tree-data-node-base';
import styles from './sds-tree-total-data-node.lit.scss';
import { colCountWithOffset } from './utilities';
/**
 * Control that represents a total data node.
 *
 * @tag sds-tree-total-data-node
 */
let SdsTreeTotalDataNode = (() => {
    var _SdsTreeTotalDataNode_selected_accessor_storage, _SdsTreeTotalDataNode_value_accessor_storage, _SdsTreeTotalDataNode_valueContainer_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tree-total-data-node')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTreeDataNodeBase;
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _valueContainer_decorators;
    let _valueContainer_initializers = [];
    let _valueContainer_extraInitializers = [];
    var SdsTreeTotalDataNode = _classThis = class extends _classSuper {
        /**
         * Indicates whether this node is selected.
         */
        get selected() { return __classPrivateFieldGet(this, _SdsTreeTotalDataNode_selected_accessor_storage, "f"); }
        set selected(value) { __classPrivateFieldSet(this, _SdsTreeTotalDataNode_selected_accessor_storage, value, "f"); }
        /**
         * Total data to be displayed in the node.
         */
        get value() { return __classPrivateFieldGet(this, _SdsTreeTotalDataNode_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsTreeTotalDataNode_value_accessor_storage, value, "f"); }
        get valueContainer() { return __classPrivateFieldGet(this, _SdsTreeTotalDataNode_valueContainer_accessor_storage, "f"); }
        set valueContainer(value) { __classPrivateFieldSet(this, _SdsTreeTotalDataNode_valueContainer_accessor_storage, value, "f"); }
        constructor() {
            super();
            _SdsTreeTotalDataNode_selected_accessor_storage.set(this, __runInitializers(this, _selected_initializers, false));
            _SdsTreeTotalDataNode_value_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _value_initializers, '')));
            _SdsTreeTotalDataNode_valueContainer_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _valueContainer_initializers, void 0)));
            __runInitializers(this, _valueContainer_extraInitializers);
            this._isLeaf = true;
        }
        get hasFrozenColumns() {
            return this.frozenColumns !== 0;
        }
        freezeColumns(count) {
            if (count !== 0) {
                this.valueContainer.classList.add('sds-tree-cell__frozen');
                this.freezeValueColumn();
            }
        }
        unFreezeAllColumns() {
            this.valueContainer.classList.remove('sds-tree-cell__frozen');
        }
        addBorderOnScroll() {
            this.valueContainer.classList.add('sds-tree-cell__scroll-border');
        }
        removeBorderOnScroll() {
            this.valueContainer.classList.remove('sds-tree-cell__scroll-border');
        }
        renderLeafIcon() {
            return html `
            <sds-icon size="16" name="sum" class="sds-tree__icon sds-tree__icon--sum"></sds-icon>
        `;
        }
        renderNodeControl() {
            return undefined;
        }
        conceal() {
            return undefined;
        }
        reveal() {
            return undefined;
        }
        renderData() {
            return html `
            <style>
                .value-container {
                    grid-column: 4/${colCountWithOffset(this.frozenColumns) + 1};
                    ${this.hasFrozenColumns ? 'position: sticky' : undefined};
                }
            </style>
            <style>
                .placeholder {
                    grid-column: ${colCountWithOffset(this.frozenColumns) + 1}/${colCountWithOffset(this.columns) + 1};
                }
            </style>
            <style>
                :host-context(html[dir='ltr']) .value-container {
                    padding-left: ${32 * this.level + (this.level - 1) * 8 + 12}px !important;
                }

                :host(:dir(ltr)) .value-container {
                    padding-left: ${32 * this.level + (this.level - 1) * 8 + 12}px !important;
                }

                :host-context([dir='rtl']) .value-container {
                    padding-right: ${32 * this.level + (this.level - 1) * 8 + 12}px !important;
                }

                :host(:dir(rtl)) .value-container {
                    padding-right: ${32 * this.level + (this.level - 1) * 8 + 12}px !important;
                }
            </style>

            <div class="value-container sds-tree-cell">${this.value}</div>
            <div class="placeholder"></div>
        `;
        }
        renderNodes() {
            return undefined;
        }
        freezeValueColumn() {
            var _a;
            const tree = this.closest('sds-tree');
            if (!isNil(tree)) {
                freezePosition(this.valueContainer, tree, (_a = tree.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('grid-container'));
            }
        }
    };
    _SdsTreeTotalDataNode_selected_accessor_storage = new WeakMap();
    _SdsTreeTotalDataNode_value_accessor_storage = new WeakMap();
    _SdsTreeTotalDataNode_valueContainer_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTreeTotalDataNode");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _selected_decorators = [property({ type: Boolean, reflect: true })];
        _value_decorators = [property({ type: String })];
        _valueContainer_decorators = [query('.value-container')];
        __esDecorate(_classThis, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, _valueContainer_decorators, { kind: "accessor", name: "valueContainer", static: false, private: false, access: { has: obj => "valueContainer" in obj, get: obj => obj.valueContainer, set: (obj, value) => { obj.valueContainer = value; } }, metadata: _metadata }, _valueContainer_initializers, _valueContainer_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTreeTotalDataNode = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTreeTotalDataNode = _classThis;
})();
export { SdsTreeTotalDataNode };
